/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Os_Thumb_WarningInputs */

const en_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not designed for thumb-scrolling enthusiasts.`)
};

const ar_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير مخصص لعشاق التمرير بالإبهام.`)
};

const bn_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`থাম্ব দিয়ে স্ক্রল করার জন্য বানানো হয়নি।`)
};

const de_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts für Fans des Scrollens per Daumen.`)
};

const es_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No está diseñado para entusiastas del desplazamiento con el pulgar.`)
};

const fr_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non conçu pour les amateurs de défilement avec le pouce.`)
};

const pt_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi projetado para entusiastas de rolagem com o polegar.`)
};

const zh_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是为拇指滚动爱好者设计的。`)
};

const tr_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başparmak kaydırma meraklıları için tasarlanmamıştır.`)
};

const ru_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не предназначен для любителей прокрутки большим пальцем.`)
};

const pl_os_thumb_warning = /** @type {(inputs: Os_Thumb_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie jest przeznaczony dla entuzjastów przewijania kciukiem.`)
};

/**
* | output |
* | --- |
* | "Not designed for thumb-scrolling enthusiasts." |
*
* @param {Os_Thumb_WarningInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const os_thumb_warning = /** @type {((inputs?: Os_Thumb_WarningInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Os_Thumb_WarningInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_os_thumb_warning(inputs)
	if (locale === "bn") return bn_os_thumb_warning(inputs)
	if (locale === "de") return de_os_thumb_warning(inputs)
	if (locale === "es") return es_os_thumb_warning(inputs)
	if (locale === "fr") return fr_os_thumb_warning(inputs)
	if (locale === "pt") return pt_os_thumb_warning(inputs)
	if (locale === "zh") return zh_os_thumb_warning(inputs)
	if (locale === "tr") return tr_os_thumb_warning(inputs)
	if (locale === "ru") return ru_os_thumb_warning(inputs)
	if (locale === "pl") return pl_os_thumb_warning(inputs)
	return en_os_thumb_warning(inputs)
});